
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#05B5E4","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill-opacity":".1","cx":"28","cy":"28","r":"28"}}),_c('path',{attrs:{"d":"M42.64 18.382a1.25 1.25 0 01-.032 1.767l-18.1 17.502a1.25 1.25 0 01-1.637.087l-.022-.018a.98.98 0 01-.093-.084l-9.39-9.457a1.25 1.25 0 111.768-1.768l8.528 8.58 17.21-16.64a1.25 1.25 0 011.767.03z"}})])])
          )
        }
      }
    